{
  "ru": {
    "detailsCarouselCard": {
      "transfers": "0 пересадок | {n} пересадка | {n} пересадки | {n} пересадок",
      "direct": "Прямой",
      "flightDetails": "Детали перелета",
      "newHandLuggage": "Ручная кладь: теперь {n} кг",
      "increasedFromMarch": "Норма увеличена с 1 марта 2026",
      "increasedBy": "+2 кг"
    }
  },
  "kk": {
    "detailsCarouselCard": {
      "transfers": "{n} ауысып отыру",
      "direct": "Тікелей",
      "flightDetails": "Ұшу туралы мәлімет",
      "newHandLuggage": "Қол жүгі: {n} кг",
      "increasedFromMarch": "Норма 2026 жылғы 1 наурыздан бастап арттырылды",
      "increasedBy": "+2 кг"
    }
  },
  "en": {
    "detailsCarouselCard": {
      "transfers": "{n} transfers",
      "direct": "Direct",
      "flightDetails": "Flight details",
      "newHandLuggage": "Hand luggage: now {n} kg",
      "increasedFromMarch": "Increased from March 1, 2026",
      "increasedBy": "+2 kg"
    }
  }
}
